import { render, staticRenderFns } from "./performance-summary-drill-down.vue?vue&type=template&id=afa89ae2&scoped=true"
import script from "./performance-summary-drill-down.ts?vue&type=script&lang=ts&external"
export * from "./performance-summary-drill-down.ts?vue&type=script&lang=ts&external"
import style0 from "./performance-summary-drill-down.scss?vue&type=style&index=0&id=afa89ae2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa89ae2",
  null
  
)

export default component.exports